// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.propertyGrid_IVc9m {
  width: 100%;
  border: 1px solid var( --color-base100 );
  padding: var( --size-padMedium ) var( --size-padMedium ) var( --size-padLarge );
  background-color: var( --color-base025 );
}
.propertyGrid_IVc9m.propertyGrid-vertical_Eq8e4 {
  background-color: var( --color-background2 );
}
.propertyGrid_IVc9m.propertyGrid-twoColumns_G8AZT {
  background-color: var( --color-background2 );
}
.propertyGrid_IVc9m.propertyGrid-operatingHours_t9nAM {
  padding-left: 0px;
  padding-right: 0px;
  background-color: transparent;
  border-top-width: 0px;
  border-top-color: transparent;
  border-left-width: 0px;
  border-left-color: transparent;
  border-right-width: 0px;
  border-right-color: transparent;
  border-bottom-width: 0px;
  border-bottom-color: transparent;
}
.propertyGrid_IVc9m.propertyGrid-operatingHoursTimezone_TRxl8 {
  padding-top: 16px;
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
}
.propertyGrid_IVc9m.propertyGrid-editor_sGkju {
  width: 100%;
  border: 1.5px solid var( --color-base200 );
  padding: var( --size-padXLarge );
  border-radius: 4px;
  background-color: var( --color-base025 );
}
.propertyGrid_IVc9m.propertyGrid-editor_sGkju.propertyGrid-attributeCoordinateEditor_E2EVJ {
  padding-top: 0px;
  margin-left: 0px;
  padding-left: 0px;
  background-color: transparent;
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
}
.propertyGrid_IVc9m.propertyGrid-conditionRule_fSRX8 {
  border-radius: 2px;
}
.propertyGrid_IVc9m.propertyGrid-overrideEditor_VWW8m {
  border-top-width: 0px;
  border-top-style: solid;
}
.propertyGrid_IVc9m.propertyGrid-tempUserEditor_PltYJ {
  border-radius: 0px;
  background-color: var( --color-base050 );
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
}
.propertyGrid_IVc9m.propertyGrid-tempUserEditor_PltYJ.propertyGrid-shareTempUser_zgG0X {
  background-color: transparent;
}
.propertyGrid_IVc9m.propertyGrid-attributeEditor_hnLJy {
  padding-left: 0px;
  padding-right: 0px;
  background-color: transparent;
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
}
.propertyGrid_IVc9m.propertyGrid-imagesListEditor_nKlCs {
  width: 100%;
  padding: var( --size-padLarge ) var( --size-padMedium );
  background-color: transparent;
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
}
.propertyGrid_IVc9m.propertyGrid-editor_sGkju.propertyGrid-runInference_Xky3O {
  min-width: 400px;
}
.propertyGrid_IVc9m.propertyGrid-rsrcGalleryEditor_joFnV {
  width: 100%;
}
.propertyGrid_IVc9m.propertyGrid-rsrcEditor_PV_4s {
  border: 1px solid transparent;
  padding: var( --size-padLarge );
  background-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/theme/PropertyGrid.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,wCAAwC;EACxC,+EAA+E;EAC/E,wCAAwC;AAC1C;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,qBAAqB;EACrB,6BAA6B;EAC7B,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,+BAA+B;EAC/B,wBAAwB;EACxB,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,0CAA0C;EAC1C,gCAAgC;EAChC,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,uDAAuD;EACvD,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,6BAA6B;AAC/B","sourcesContent":[".propertyGrid {\n  width: 100%;\n  border: 1px solid var( --color-base100 );\n  padding: var( --size-padMedium ) var( --size-padMedium ) var( --size-padLarge );\n  background-color: var( --color-base025 );\n}\n.propertyGrid.propertyGrid-vertical {\n  background-color: var( --color-background2 );\n}\n.propertyGrid.propertyGrid-twoColumns {\n  background-color: var( --color-background2 );\n}\n.propertyGrid.propertyGrid-operatingHours {\n  padding-left: 0px;\n  padding-right: 0px;\n  background-color: transparent;\n  border-top-width: 0px;\n  border-top-color: transparent;\n  border-left-width: 0px;\n  border-left-color: transparent;\n  border-right-width: 0px;\n  border-right-color: transparent;\n  border-bottom-width: 0px;\n  border-bottom-color: transparent;\n}\n.propertyGrid.propertyGrid-operatingHoursTimezone {\n  padding-top: 16px;\n  border-top-width: 0px;\n  border-left-width: 0px;\n  border-right-width: 0px;\n  border-bottom-width: 0px;\n}\n.propertyGrid.propertyGrid-editor {\n  width: 100%;\n  border: 1.5px solid var( --color-base200 );\n  padding: var( --size-padXLarge );\n  border-radius: 4px;\n  background-color: var( --color-base025 );\n}\n.propertyGrid.propertyGrid-editor.propertyGrid-attributeCoordinateEditor {\n  padding-top: 0px;\n  margin-left: 0px;\n  padding-left: 0px;\n  background-color: transparent;\n  border-top-width: 0px;\n  border-left-width: 0px;\n  border-right-width: 0px;\n  border-bottom-width: 0px;\n}\n.propertyGrid.propertyGrid-conditionRule {\n  border-radius: 2px;\n}\n.propertyGrid.propertyGrid-overrideEditor {\n  border-top-width: 0px;\n  border-top-style: solid;\n}\n.propertyGrid.propertyGrid-tempUserEditor {\n  border-radius: 0px;\n  background-color: var( --color-base050 );\n  border-top-width: 0px;\n  border-left-width: 0px;\n  border-right-width: 0px;\n  border-bottom-width: 0px;\n}\n.propertyGrid.propertyGrid-tempUserEditor.propertyGrid-shareTempUser {\n  background-color: transparent;\n}\n.propertyGrid.propertyGrid-attributeEditor {\n  padding-left: 0px;\n  padding-right: 0px;\n  background-color: transparent;\n  border-top-width: 0px;\n  border-left-width: 0px;\n  border-right-width: 0px;\n  border-bottom-width: 0px;\n}\n.propertyGrid.propertyGrid-imagesListEditor {\n  width: 100%;\n  padding: var( --size-padLarge ) var( --size-padMedium );\n  background-color: transparent;\n  border-top-width: 0px;\n  border-left-width: 0px;\n  border-right-width: 0px;\n  border-bottom-width: 0px;\n}\n.propertyGrid.propertyGrid-editor.propertyGrid-runInference {\n  min-width: 400px;\n}\n.propertyGrid.propertyGrid-rsrcGalleryEditor {\n  width: 100%;\n}\n.propertyGrid.propertyGrid-rsrcEditor {\n  border: 1px solid transparent;\n  padding: var( --size-padLarge );\n  background-color: transparent;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"propertyGrid": `propertyGrid_IVc9m`,
	"propertyGrid-vertical": `propertyGrid-vertical_Eq8e4`,
	"propertyGrid-twoColumns": `propertyGrid-twoColumns_G8AZT`,
	"propertyGrid-operatingHours": `propertyGrid-operatingHours_t9nAM`,
	"propertyGrid-operatingHoursTimezone": `propertyGrid-operatingHoursTimezone_TRxl8`,
	"propertyGrid-editor": `propertyGrid-editor_sGkju`,
	"propertyGrid-attributeCoordinateEditor": `propertyGrid-attributeCoordinateEditor_E2EVJ`,
	"propertyGrid-conditionRule": `propertyGrid-conditionRule_fSRX8`,
	"propertyGrid-overrideEditor": `propertyGrid-overrideEditor_VWW8m`,
	"propertyGrid-tempUserEditor": `propertyGrid-tempUserEditor_PltYJ`,
	"propertyGrid-shareTempUser": `propertyGrid-shareTempUser_zgG0X`,
	"propertyGrid-attributeEditor": `propertyGrid-attributeEditor_hnLJy`,
	"propertyGrid-imagesListEditor": `propertyGrid-imagesListEditor_nKlCs`,
	"propertyGrid-runInference": `propertyGrid-runInference_Xky3O`,
	"propertyGrid-rsrcGalleryEditor": `propertyGrid-rsrcGalleryEditor_joFnV`,
	"propertyGrid-rsrcEditor": `propertyGrid-rsrcEditor_PV_4s`
};
export default ___CSS_LOADER_EXPORT___;
